import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as userActions from "../../redux/actions/usersActions";

const getToken = location => new URLSearchParams((location && location.search) || "").get("token");

export function EmailVerificationPage({ location, confirmEmailVerification }) {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = getToken(location);
    if (!token) {
      setStatus("error");
      return;
    }

    confirmEmailVerification(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [location, confirmEmailVerification]);

  return (
    <div className="quiz-text email-verification-page">
      {status === "loading" && (
        <div role="status" className="alert alert-info email-verification-message">
          Weryfikujemy adres email...
        </div>
      )}
      {status === "success" && (
        <div role="status" className="alert alert-success email-verification-message">
          <h2>Adres email został potwierdzony.</h2>
          <p>Możesz teraz zalogować się do portalu Extra English.</p>
          <Link className="btn manage-button manage-red-button" to="/manage/login">Przejdź do logowania</Link>
        </div>
      )}
      {status === "error" && (
        <div role="alert" className="alert alert-danger email-verification-message">
          <h2>Nie udało się potwierdzić adresu email.</h2>
          <p>Link weryfikacyjny jest nieprawidłowy albo wygasł.</p>
          <p>Wróć do logowania i poproś o ponowne wysłanie linku lub skontaktuj się z administratorem szkoły.</p>
          <Link className="btn manage-button manage-red-button" to="/manage/login">Przejdź do logowania</Link>
        </div>
      )}
    </div>
  );
}

EmailVerificationPage.propTypes = {
  location: PropTypes.shape({ search: PropTypes.string }),
  confirmEmailVerification: PropTypes.func.isRequired,
};

EmailVerificationPage.defaultProps = {
  location: { search: "" },
};

export default connect(null, {
  confirmEmailVerification: userActions.confirmEmailVerification,
})(EmailVerificationPage);
